<template>
  <div class="change-phone customer-common">
    <div class="retr-head">
      <div :class="['step-1', step === 0 ? 'active' : '']">1.验证账号密码</div>
      <div :class="['step-2', step === 1 ? 'active' : '']">2.设置新手机</div>
    </div>
    <div class="container cus-style">
      <div v-show="!step">
        <div class="input">
          <van-field
            v-model="phone"
            center
            clearable
            placeholder="请输入注册手机号码"
            maxlength="11"
            :error="validate.reg_verify_err.phone"
            @change="validate.tel('phone')"
          >
            <!-- <div slot="left-icon" class="inp-ico phone-ico"></div> -->
          </van-field>
          <van-field
            v-model="pwd"
            type="password"
            center
            clearable
            placeholder="请输入账号密码"
          >
            <!-- <div slot="left-icon" class="inp-ico pwd-ico"></div> -->
          </van-field>
        </div>
        <div class="next-btn">
          <van-button
            size="large"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            @click="netxStep"
            :loading="checkLoading"
            >下一步</van-button
          >
        </div>
      </div>
      <div v-show="step">
        <div class="input">
          <van-field
            v-model="newphone"
            center
            clearable
            maxlength="11"
            placeholder="请输入新的手机号码"
            :error="validate.reg_verify_err.newphone"
            @change="validate.tel('newphone')"
          >
            <!-- <div slot="left-icon" class="inp-ico phone-ico"></div> -->
          </van-field>
          <van-field
            v-model="code"
            center
            clearable
            placeholder="请输入短信验证码"
            type="digit"
            max-length="6"
            :error="validate.reg_verify_err.code"
            @change="validate.code('code')"
          >
            <!-- <div slot="left-icon" class="inp-ico mail-ico"></div> -->

            <template #button>
              <span
                size="small"
                round
                @click="sendCode"
                style="color: #6cdd8f"
                >{{ sendClip ? "发送验证码" : `${second}s` }}</span
              >
            </template>
          </van-field>
        </div>
        <div class="next-btn">
          <van-button
            size="large"
            :loading="subloding"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            @click="submitReset"
            >完成</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  checkPhonePwd,
  getCodeBeforeChangeTel,
  userChangeTel
} from "@/utils/api/user";
import { validate } from "@/utils/mixin/validate";
export default {
  mixins: [validate],
  data() {
    return {
      checkLoading: false,
      phone: "",
      newphone: "",
      code: "",
      step: 0,
      pwd: "",
      sendClip: true,
      subloding: false,
      itv: null,
      second: 60
    };
  },
  methods: {
    // 验证账号密码
    netxStep() {
      this.checkLoading = true;
      const res = this.validate.tel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        this.checkLoading = false;
        return;
      }
      checkPhonePwd({
        code: this.phone,
        password: this.pwd
      }).then((res) => {
        if (res.success) {
          this.step++;
        }
        this.checkLoading = false;
      });
    },
    // 发送验证码
    sendCode() {
      if (!this.sendClip) {
        return;
      }
      const res = this.validate.tel("newphone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      getCodeBeforeChangeTel({ code: this.newphone }).then((res) => {
        if (res.success) {
          this.sendClip = false;
          this.codeInterval();
        }
      });
    },
    // 倒计时
    codeInterval() {
      this.itv = setInterval(() => {
        this.second--;
        if (!this.second) {
          this.second = 60;
          this.sendClip = true;
          window.clearInterval(this.itv);
        }
      }, 1000);
    },
    // 换绑手机提交
    submitReset() {
      this.subloding = true;
      const res = this.validate.tel("newphone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        this.subloding = false;
        return;
      }
      userChangeTel({
        code: this.newphone,
        telCode: this.code
      }).then((res) => {
        if (res.success) {
          this.$root.$toast.success({
            message: "设置成功！",
            duration: 1500,
            onClose: () => {
              this.$router.push("/login");
              // this.$store.commit("setUserInfo", {});
              // const role = this.$store.state.role;
              // switch (role) {
              //   case 0:
              //     break;
              //   case 1:
              //     this.$router.push("/loginjudge");
              //     break;
              //   case 2:
              //     this.$router.push("/loginorg");
              //     break;
              //   case 3:
              //     this.$router.push("/loginchannel");
              //     break;
              //   default:
              //     this.$router.push("/loginchoice");
              //     break;
              // }
            }
          });
        }
        this.subloding = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.change-phone {
  min-height: 100vh;
  min-width: 100vw;
  overflow: hidden;
  .retr-head {
    position: relative;
    height: 44px;
    border-bottom: 1px solid #f2f2f2;
    width: 100vw;
    & > div {
      position: absolute;
      height: 100%;
      width: 50%;
      text-align: center;
      font-size: 13px;
      color: #999;
      line-height: 46px;
    }
    .step-1 {
      z-index: 5;
      background-color: #fff;
      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: -16px;
        width: 0;
        height: 0;
        border-top: 22px solid transparent;
        border-left: 16px solid #fff;
        border-bottom: 22px solid transparent;
        z-index: 2;
      }
      &.active {
        background-color: #fdfcfc;
        &::before {
          border-left: 16px solid #fdfcfc;
        }
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: -17.5px;
        width: 0;
        height: 0;
        border-top: 22px solid transparent;
        border-left: 16px solid #f2f2f2;
        border-bottom: 22px solid transparent;
        z-index: 1;
      }
    }
    .step-2 {
      right: 0;
      z-index: 1;
      &.active {
        background-color: #fdfcfc;
      }
    }
  }
  .container {
    width: 335px;
    margin: 0 auto;
    margin-top: 20px;
    .input {
      width: 335px;
      overflow: hidden;
      border-radius: 5px;
      margin: 0 auto;
      .pwd-ico {
        background: url("../../assets/images/login/password.png") no-repeat;
      }
      .rpwd-ico {
        background: url("../../assets/images/login/password.png") no-repeat;
      }
      .phone-ico {
        background: url("../../assets/images/login/phone.png") no-repeat;
      }
      .mail-ico {
        background: url("../../assets/images/login/mail.png") no-repeat;
      }
      .inp-ico {
        width: 55px;
        height: 55px;
        background-size: 20px 20px;
        background-position: center center;
      }
    }
    .next-btn {
      margin-top: 20px;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
.change-phone {
  .input {
    .van-field__button {
      padding-right: 12px;
    }
  }
  .next-btn {
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
}
</style>
